import { PlatformType } from '../../../types';
import { useGamesStore } from '../../store';

export const useGamesIsLoaded = (feedName: string, platform: PlatformType) => {
  return useGamesStore(
    (store) =>
      store.feeds[feedName]?.isLoaded &&
      store.feeds[feedName]?.platform === platform
  );
};
